import { jsx as _jsx } from "react/jsx-runtime";
export function TableHead({ children, style }) {
    return (_jsx("th", { style: style, className: "p-stack-roomy text-left text-fg-muted font-medium text-body-sm text-nowrap", children: children }));
}
